import {useDebugValue} from 'react';

import {useOptions} from './';

const defaultOptions = {
    allowErrorHighlighting: false,
    allowSummary: false,
    autoProgress: true,
    autoSubmit: true,
    layout: 'standard',
    align: 'center',
    showIcons: true,
    showGuestsDetailsInputField: true,
    showSubmitDetailsButtonField: true
};

function useFormOptions(props) {
    const {
        formOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useFormOptions};
